// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_23NAE","popoverWrapper":"_23NAE","root":"pmf1g"};